export type Variant = 'left' | 'right' | 'leftOnDesk' | 'rightOnDesk' | 'leftOnAll' | 'rightOnAll' | 'full'
export type GetDefaultClassesOptions = { hasNoGridItem?: boolean }
export const getDefaultClasses = (variant: Variant = 'full', options?: GetDefaultClassesOptions) => {
  const classes: string[] = []
  if (options?.hasNoGridItem === undefined || options?.hasNoGridItem === false) classes.push('grid-item')
  classes.push('one-whole')

  switch (variant) {
    case 'left':
      classes.push('lap-one-half', 'desk-one-half', 'lap-padding-right-m', 'desk-padding-right-m')
      break
    case 'right':
      classes.push('lap-one-half', 'desk-one-half', 'lap-padding-left-m', 'desk-padding-left-m')
      break
    case 'leftOnDesk':
      classes.push('desk-one-half', 'desk-padding-right-m')
      break
    case 'rightOnDesk':
      classes.push('desk-one-half', 'desk-padding-left-m')
      break
    case 'leftOnAll':
      classes.push('one-half', 'padding-right-m')
      break
    case 'rightOnAll':
      classes.push('one-half', 'padding-left-m')
  }
  return classes.join(' ')
}
